export default {
  'dashboard.totalUsers': 'कुल सक्रिय उपयोगकर्ता',
  'dashboard.collectedEmis': 'वसूल EMI',
  'dashboard.closedHps': 'बंद HP',
  'dashboard.totalLoan': 'कुल ऋण राशि',
  'dashboard.vehiclesAvailable': 'उपलब्ध वाहन',
  'dashboard.vehiclesSold': 'बिके वाहन',
  'dashboard.handLoans': 'हाथ ऋण',
  'dashboard.seizedHps': 'जब्त HP',
  'dashboard.overview': 'अवलोकन',
  'dashboard.exportReport': 'रिपोर्ट निर्यात करें',
  'dashboard.overviewSub': '{{range}} के लिए शेष और थ्रूपुट। खाता विवरण और ड्रिल-डाउन के लिए किसी भी कार्ड को खोलें।',
  'dashboard.collectionsTrend': 'वसूली प्रवृत्ति',
  'dashboard.collectionsTrendSub': 'EMI रसीदें और विलंब शुल्क महीने के अनुसार — {{range}}',
  'dashboard.portfolioSplit': 'पोर्टफोलियो विभाजन',
  'dashboard.topBorrowers': 'बकाया के अनुसार शीर्ष उधारकर्ता',
  'dashboard.quickActions': 'त्वरित कार्रवाई',
  'dashboard.newFinance': 'नया वित्त',
  'dashboard.newHandLoan': 'नया हाथ ऋण',
  'dashboard.consultancyDesk': 'परामर्श डेस्क',
  'dashboard.collected': 'वसूल',
  'dashboard.noData': 'इस अवधि में कोई डेटा नहीं',

  'master.title': 'डैशबोर्ड',
  'master.financeIncome': 'वित्त आय',
  'master.totalRevenue': 'कुल राजस्व',
  'master.interestCollectedHint': 'वसूला ब्याज',
  'master.revenueHint': 'वसूला ब्याज + विलंब शुल्क',
  'master.interestWithYtdHint': 'अवधि ब्याज + विलंब शुल्क + YTD शुरुआती बीज',
  'master.portfolioHint': 'सक्रिय पोर्टफोलियो बकाया',
  'master.borrowersHint': 'उधारकर्ता',
  'master.openingCash': 'हाथ में नकद',
  'master.openingBank': 'बैंक शेष',
  'master.openingBooksHint': 'ओपनिंग बुक्स / कटओवर से',
  'master.liveCashHint': 'ओपनिंग नकद + वसूली − ऋण, खर्च और अग्रिम',
  'master.liveBankHint': 'ओपनिंग बैंक + क्रेडिट − डेबिट (कटओवर के बाद)',
  'master.financeProfit': 'वित्त लाभ',
  'master.profitFormula': 'राजस्व − खर्च',
  'master.netFormula': 'वित्त राजस्व + परामर्श लाभ − खर्च',
  'master.emiCollected': 'कुल EMI वसूली',
  'master.cashBankHint': 'नकद प्राप्त / बैंक क्रेडिट = वसूली। नकद दिया / बैंक डेबिट = दिया गया ऋण।',
  'master.financeSectionHint': 'राजस्व = वसूला ब्याज + विलंब शुल्क (+ YTD बीज जब लागू)। लाभ = राजस्व − खर्च। EMI वसूली = ऋण नकद (रसीद में मूल + ब्याज)।',
  'master.consultancySectionHint': 'वाहन बिक्री डेस्क — चयनित अवधि का राजस्व, लागत और लाभ।',
  'master.consultancyProfit': 'परामर्श लाभ',
  'master.expenses': 'कुल खर्च',
  'master.netAccounting': 'शुद्ध लाभ',
  'master.tabCombined': 'संयुक्त',
  'master.tabFinance': 'वित्त',
  'master.tabConsultancy': 'परामर्श',
  'master.incomeVsExpenses': 'राजस्व बनाम खर्च',
  'master.monthlyCollections': 'मासिक वसूली और ब्याज',
  'master.revenueVsProfit': 'राजस्व बनाम लाभ',
  'master.spendByCategory': 'श्रेणी के अनुसार खर्च',

  'accounts.title': 'खाते और माइग्रेशन',
  'accounts.subtitle': 'वित्तीय वर्ष के लिए कटओवर तारीख और ओपनिंग बैलेंस सेट करें।',
  'accounts.howtoTitle': '3 चरणों में गो-लाइव',
  'accounts.howto1': 'कटओवर तिथि और ओपनिंग बैलेंस सेट करें (नकद, बैंक, पूंजी, ऋण प्राप्य)।',
  'accounts.howto2': 'प्रत्येक सक्रिय वित्त / हाथ ऋण को बकाया + अगली देय तिथि के साथ माइग्रेट करें।',
  'accounts.howto3': 'कटओवर के बाद केवल इसी सॉफ़्टवेयर में भुगतान और खर्च दर्ज करें।',
  'accounts.tabOpening': 'ओपनिंग बुक्स',
  'accounts.tabMigrateFinance': 'वित्त माइग्रेट',
  'accounts.tabMigrateHand': 'हाथ ऋण माइग्रेट',
  'accounts.tabMigrated': 'माइग्रेटेड सूची',
  'accounts.openingHeading': 'कटओवर पर ओपनिंग बैलेंस',
  'accounts.cutoverDate': 'कटओवर / गो-लाइव तिथि',
  'accounts.cutoverHint': 'पुस्तकें और माइग्रेटेड ऋण इसी तिथि से शुरू होते हैं।',
  'accounts.portfolioCheck': 'माइग्रेट किए गए ऋणों का बकाया',
  'accounts.booksOutstanding': 'पुस्तक ऋण प्राप्य',
  'accounts.mismatchHint': 'मेल नहीं खाता',
  'accounts.matchedHint': 'मेल खाता है',
  'accounts.notes': 'माइग्रेशन नोट्स',
  'accounts.notesPlaceholder': 'उदा. भौतिक पुस्तकों से माइग्रेट…',
  'accounts.saveOpening': 'ओपनिंग बुक्स सहेजें',
  'accounts.fillFromPortfolio': 'पोर्टफोलियो से ऋण प्राप्य भरें',
  'accounts.migrateFinanceTitle': 'मौजूदा वित्त सुविधा माइग्रेट करें',
  'accounts.migrateFinanceHint': 'आज की स्थिति दर्ज करें: बकाया मूल, शेष EMI, अगली देय।',
  'accounts.migrateHandTitle': 'मौजूदा हाथ ऋण माइग्रेट करें',
  'accounts.migrateHandHint': 'बकाया मूल और देय ब्याज के साथ सक्रिय हाथ ऋण लाएँ।',
  'accounts.migrateWarning': 'पुरानी हर EMI दोबारा दर्ज न करें। केवल बकाया + शेष शेड्यूल।',
  'accounts.saveMigratedFinance': 'माइग्रेटेड वित्त सहेजें',
  'accounts.saveMigratedHand': 'माइग्रेटेड हाथ ऋण सहेजें',
  'accounts.migratedFinance': 'माइग्रेटेड वित्त सुविधाएँ',
  'accounts.migratedHand': 'माइग्रेटेड हाथ ऋण',
  'accounts.noneMigrated': 'अभी कोई माइग्रेटेड सुविधा नहीं।',
  'accounts.openErpFy': 'Finance ERP खोलें',
  'accounts.erpSharedHint': 'नकद, बैंक, पूंजी आदि ओपनिंग बैलेंस Finance ERP → वित्तीय वर्ष के समान हैं। यहाँ सहेजने पर वही FY अपडेट होता है।',
  'accounts.localOpeningHint': 'ओपनिंग बैलेंस इस लेजर बुक के लिए सहेजे जाते हैं। Finance या audit एक्सेस होने पर ERP सिंक उपलब्ध है।',
  'accounts.fyBalancesHeading': 'वित्तीय वर्ष ओपनिंग (ERP के साथ साझा)',
  'accounts.ytdHeading': 'वैकल्पिक मध्य-वर्ष P&L सीड (केवल Accounts)',

  'customers.title': 'ग्राहक',
  'customers.addHint': 'वित्त मामले या हाथ ऋण जोड़ें — प्रत्येक सुविधा यहाँ उधारकर्ता के साथ लाइव शेष के साथ दिखाई देती है।',
  'customers.financeDesk': 'वित्त डेस्क',
  'customers.handLoans': 'हाथ ऋण',
  'customers.backOverview': 'अवलोकन पर वापस',
  'customers.totalPrincipal': 'कुल मूलधन',
  'customers.amountCollected': 'वसूल राशि',
  'customers.principalOutstanding': 'बकाया मूलधन',
  'customers.totalDue': 'कुल देय राशि',
  'customers.pageTitle': 'ग्राहक',
  'customers.exportTitle': 'ग्राहक रिपोर्ट',
  'customers.filterFileStatus': 'फ़ाइल स्थिति',
  'customers.filterStatusAll': 'सभी फ़ाइलें',
  'customers.filterActive': 'सक्रिय',
  'customers.filterClosed': 'बंद',
  'customers.badgeActive': 'सक्रिय',
  'customers.badgeClosed': 'बंद',

  'customer.tabOverview': 'अवलोकन',
  'customer.tabHistory': 'इतिहास',
  'customer.tabAlerts': 'अलर्ट',
  'customer.accountSummary': 'खाता सारांश',
  'customer.overdueDays': 'अतिदेय दिन',
  'customer.unpaidOverdueDays': 'अवैतनिक अतिदेय दिन',
  'customer.calculatedPenalty': 'गणना किया गया जुर्माना',
  'customer.loggedLateFees': 'बकाया विलंब शुल्क',
  'customer.lateFeesDue': 'बकाया विलंब शुल्क',
  'customer.lateFeesBalance': 'विलंब शेष',
  'customer.noOverdue': 'इस ग्राहक के लिए कोई अतिदेय दिन दर्ज नहीं है।',
  'customer.viewMissedDates': 'छूटी तिथियाँ देखें',
  'customer.smsReminder': 'SMS अनुस्मारक',
  'customer.cashIn': 'नकद प्राप्ति',
  'customer.cashCollected': 'नकद वसूल',
  'customer.interestRecognized': 'मान्यता प्राप्त ब्याज',
  'customer.ledgerInterest': 'ब्याज (लेजर विभाजन)',
  'customer.nextInstallment': 'अगली किस्त',
  'customer.noUpcomingEmi': 'कोई आगामी EMI नहीं – नीचे प्रत्येक सुविधा पर अवधि और EMI जाँचें।',
  'customer.facilityTable': 'ऋण सुविधाएँ — EMI वसूलें',
  'customer.facilityTableSub': 'महीने, EMI राशि, और प्रत्येक ऋण के लिए वसूली',
  'customer.installmentSchedule': 'पूर्ण किस्त अनुसूची',
  'customer.upcomingCashflow': 'महीने के अनुसार आगामी नकदी प्रवाह',
  'customer.paymentHistory': 'भुगतान इतिहास',
  'customer.alerts': 'अलर्ट',
  'customer.recordPayment': 'EMI वसूलें',
  'customer.collectEmis': 'EMI वसूलें',
  'customer.emisComplete': 'EMI पूर्ण',
  'customer.collectionCol': 'वसूली',
  'customer.closeFile': 'फ़ाइल बंद करें',
  'customer.refinance': 'पुनर्वित्त',
  'customer.markSeized': 'जब्त चिह्नित करें',
  'customer.due': 'देय',
  'customer.facility': 'सुविधा',
  'customer.kind': 'प्रकार',
  'customer.note': 'नोट',
  'customer.lateFee': 'विलंब शुल्क',
  'customer.balanceAfter': 'बाद शेष',
  'customer.payoff': 'पूर्ण भुगतान',

  'finance.newApplication': 'नया आवेदन',
  'finance.noRows': 'आपकी खोज से कोई पंक्ति मेल नहीं खाती।',
  'finance.noRecords': 'अभी कोई वित्त नहीं — समर्पित आवेदन पृष्ठ खोलने के लिए नया आवेदन का उपयोग करें।',
  'finance.regHa': 'Reg / HA',
  'finance.customer': 'ग्राहक',
  'finance.emi': 'EMI',
  'finance.currentFinances': 'वर्तमान वित्त',
  'finance.editApplication': 'आवेदन संपादित करें',
  'finance.stepVehicle': 'वाहन',
  'finance.stepFinancial': 'वित्तीय',
  'finance.stepParties': 'पक्ष',
  'finance.backToList': 'सूची पर वापस',
  'finance.saveApplication': 'आवेदन सहेजें',

  'loans.borrower': 'उधारकर्ता',
  'loans.interest': 'ब्याज',
  'loans.term': 'अवधि',
  'loans.type': 'प्रकार',
  'loans.newApplication': 'नया आवेदन',
  'loans.noRows': 'आपकी खोज से कोई पंक्ति मेल नहीं खाती।',
  'loans.noRecords': 'अभी कोई हाथ ऋण नहीं — समर्पित आवेदन पृष्ठ खोलने के लिए नया आवेदन का उपयोग करें।',
  'loans.currentHandLoans': 'वर्तमान हाथ ऋण',
  'loans.stepBorrower': 'उधारकर्ता',
  'loans.stepFacility': 'सुविधा',
  'loans.repaymentEmi': 'EMI',
  'loans.repaymentShort': 'अल्प अवधि',
  'loans.saveApplication': 'आवेदन सहेजें',

  'reports.title': 'रिपोर्ट',
  'reports.subtitle': 'चयनित अवधि के लिए वित्त और हाथ ऋण गतिविधि।',
  'reports.loanType': 'ऋण प्रकार',
  'reports.serviceLine': 'सेवा लाइन',
  'reports.sortBy': 'क्रमबद्ध करें',
  'reports.financeCreated': 'वित्त बनाया गया',
  'reports.handCreated': 'हाथ ऋण बनाए गए',
  'reports.financeClosed': 'वित्त बंद',
  'reports.handClosed': 'हाथ ऋण बंद',
  'reports.financeSeized': 'वित्त जब्त',
  'reports.collections': 'वसूली',
  'reports.outstandingOverdue': 'बकाया और अतिदेय',
  'reports.financeNew': 'नया वित्त',
  'reports.financeClosedShort': 'वित्त बंद',
  'reports.seized': 'जब्त',
  'reports.handNew': 'नया हाथ ऋण',
  'reports.handClosedShort': 'हाथ ऋण बंद',
  'reports.collected': 'वसूल',
  'reports.lateFees': 'विलंब शुल्क',
  'reports.openHps': 'खुले HP',
  'reports.amtDue': 'देय राशि',
  'reports.regHa': 'Reg / HA',
  'reports.lateFee': 'विलंब शुल्क',
  'reports.menuLead': 'एक रिपोर्ट चुनें। वह अपने पेज पर खुलेगी, जहाँ से Excel या PDF डाउनलोड कर सकते हैं।',
  'reports.allReports': 'सभी रिपोर्ट',
  'reports.downloadHint': 'Excel या PDF डाउनलोड करने के लिए इस पेज पर Export File का उपयोग करें।',
  'reports.groupBooks': 'चालू बही',
  'reports.groupPeriod': 'चयनित अवधि',
  'reports.groupLedgers': 'सभी खाते',
  'reports.periodSummary': 'अवधि सारांश',
  'reports.consolidated': 'समेकित रिपोर्ट',
  'reports.overdue': 'अतिदेय',
  'reports.outstanding': 'बकाया राशि',
  'reports.descPeriod': 'चयनित अवधि की संख्या और राशि।',
  'reports.descConsolidated': 'सभी खातों की वसूली, ब्याज, खर्च और नकदी प्रवाह।',
  'reports.descFinanceCreated': 'इस अवधि में खुली वित्त फाइलें।',
  'reports.descHandCreated': 'इस अवधि में खुले हाथ ऋण।',
  'reports.descFinanceClosed': 'इस अवधि में बंद वित्त फाइलें।',
  'reports.descHandClosed': 'इस अवधि में बंद हाथ ऋण।',
  'reports.descSeized': 'इस अवधि में जब्त वाहन।',
  'reports.descCollections': 'इस अवधि में दर्ज वसूली।',
  'reports.descLateFees': 'इस अवधि में वसूला गया विलंब शुल्क।',
  'reports.descOutstanding': 'खुले ऋणों पर अभी वसूल होने वाली राशि।',
  'reports.descOverdue': 'जिन ग्राहकों का भुगतान पहले ही देर से है।',
  'reports.noOverdue': 'कोई अतिदेय ग्राहक नहीं।',
  'reports.noLateFees': 'इस अवधि में कोई विलंब शुल्क नहीं।',

  'employees.title': 'कर्मचारी और वेतन',
  'employees.subtitle': 'कर्मचारियों, वेतन और अग्रिम का प्रबंधन करें। {{range}} के लिए वेतन आँकड़े।',
  'employees.addEmployee': 'कर्मचारी जोड़ें',
  'employees.activeStaff': 'सक्रिय कर्मचारी',
  'employees.salaryPaid': 'वेतन भुगतान',
  'employees.advancesGiven': 'दिए गए अग्रिम',
  'employees.outstandingAdvances': 'बकाया अग्रिम',
  'employees.payrollReport': 'वेतन रिपोर्ट',
  'employees.salary': 'वेतन',
  'employees.advances': 'अग्रिम',
  'employees.basic': 'मूल',
  'employees.bonus': 'बोनस',
  'employees.netPay': 'शुद्ध वेतन',
  'employees.method': 'विधि',

  'expenses.title': 'खर्च',
  'expenses.subtitle': '{{range}} के लिए परिचालन खर्च ट्रैक करें।',
  'expenses.recordExpense': 'खर्च दर्ज करें',
  'expenses.categories': 'श्रेणियाँ',
  'expenses.totalSpend': 'कुल खर्च',
  'expenses.category': 'श्रेणी',
  'expenses.vendor': 'विक्रेता',
  'expenses.description': 'विवरण',
  'expenses.paidBy': 'भुगतानकर्ता',
  'expenses.paymentMethod': 'भुगतान विधि',
  'expenses.addCategory': 'श्रेणी जोड़ें',
  'expenses.spendByCategory': 'श्रेणी के अनुसार खर्च',
  'expenses.expenseReport': 'खर्च रिपोर्ट',

  'consultancy.title': 'परामर्श',
  'consultancy.vehicles': 'वाहन इन्वेंटरी',
  'consultancy.investment': 'निवेश',
  'consultancy.revenue': 'राजस्व',
  'consultancy.profit': 'लाभ',
  'consultancy.loss': 'हानि',
  'consultancy.buyStock': 'स्टॉक जोड़ें',
  'consultancy.sellStock': 'स्टॉक से बेचें',
  'consultancy.available': 'उपलब्ध',
  'consultancy.sold': 'बिका',
  'consultancy.all': 'सभी',
  'consultancy.service': 'सेवा',
  'consultancy.transactionHistory': 'लेनदेन इतिहास',
  'consultancy.filtersSort': 'फ़िल्टर और क्रमबद्ध',
  'consultancy.operationsDesk': 'ऑपरेशन डेस्क',
  'consultancy.history': 'इतिहास',

  'portal.dueNow': 'अभी देय',
  'portal.paid': 'भुगतान किया',
  'portal.schedule': 'किस्त अनुसूची',
  'portal.payments': 'भुगतान इतिहास',
  'portal.totalLoan': 'कुल ऋण',
  'portal.lateFee': 'विलंब शुल्क',
  'portal.lateDays': 'विलंब दिन',
  'portal.paidEmis': 'भुगतान EMI',
  'portal.pendingEmis': 'लंबित EMI',
  'portal.yourAccount': 'आपका खाता',
  'portal.signOut': 'साइन आउट',
  'portal.allLoans': 'सभी ऋण',

  'navbar.latePayments': 'विलंबित भुगतान',
  'navbar.noLatePayments': 'कोई विलंबित भुगतान नहीं',
  'navbar.notifications': 'सूचनाएँ',
  'navbar.account': 'खाता',
  'navbar.darkMode': 'डार्क मोड',
  'navbar.lightMode': 'लाइट मोड',

  'hub.title': 'वर्कस्पेस होम',
  'hub.subtitle': 'सभी मॉड्यूल एक जगह — वित्त, वसूली, रिपोर्ट और सेटिंग्स के लिए कोई भी कार्ड खोलें।',
  'hub.allModules': 'सभी मॉड्यूल',
  'hub.modulesCount': 'मॉड्यूल',
  'hub.modulesAria': 'एप्लिकेशन मॉड्यूल',
  'hub.backToModules': 'मॉड्यूल पर वापस',
  'hub.accountingSummary': 'लेखा सारांश',
  'hub.accountingTitle': 'P&L और नकद प्रवाह',
  'hub.emiManagement': 'EMI प्रबंधन',
  'hub.paymentsCollections': 'भुगतान और वसूली',
  'hub.overdueManagement': 'अतिदेय प्रबंधन',
  'hub.ledgers': 'लेजर',
  'hub.userManagement': 'उपयोगकर्ता प्रबंधन',
  'hub.descOverview': 'पोर्टफोलियो KPI, वसूली रुझान और दैनिक संचालन के लिए त्वरित कार्य।',
  'hub.descAccounting': 'संयुक्त P&L, वित्त आय, परामर्श लाभ, खर्च और नकद प्रवाह।',
  'hub.descCustomers': 'उधारकर्ता प्रोफ़ाइल, ऋण अनुसूची, EMI रसीदें और खाता इतिहास।',
  'hub.descFinance': 'हायर-पर्चेज वित्त सुविधाएँ बनाएँ और प्रबंधित करें।',
  'hub.descHandLoans': 'लचीली शर्तों वाले अल्पकालिक हाथ ऋण।',
  'hub.descEmi': 'देय किस्तें, रसीदें और लचीली EMI अनुसूची प्रबंधित करें।',
  'hub.descPayments': 'वसूली दर्ज करें, नकद/बैंक विभाजन और भुगतान इतिहास।',
  'hub.descOverdue': 'देर से उधारकर्ता, अतिदेय दिन और जुर्माना निगरानी।',
  'hub.descAccounts': 'प्रारंभिक पुस्तकें, माइग्रेशन और लाइव नकद/बैंक शेष।',
  'hub.descReports': 'दैनिक रिपोर्ट, पोर्टफोलियो, वसूली और अतिदेय सारांश।',
  'hub.descAudit': 'लॉगिन, अपडेट और सुरक्षा की गतिविधि लॉग।',
  'hub.descErp': 'ट्रायल बैलेंस, बैलेंस शीट, P&L, डे बुक और समाधान।',
  'hub.descConsultancy': 'वाहन इन्वेंटरी — खरीद, बिक्री, निवेश और लाभ।',
  'hub.descExpenses': 'श्रेणी के अनुसार व्यावसायिक खर्च ट्रैक करें।',
  'hub.descEmployees': 'कर्मचारी, वेतन, अग्रिम और पेरोल इतिहास।',
  'hub.descLedgers': 'मल्टी-बुक सेटअप — लेजर बनाएँ और लॉगिन असाइन करें।',
  'hub.descUsers': 'स्वामी, एडमिन, भूमिकाएँ और अनुमति प्रबंधन।',
  'hub.descSettings': 'कंपनी प्रोफ़ाइल, बैंक, SMS, भुगतान, सदस्यता और थीम।',
  'hub.statBorrowers': 'उधारकर्ता',
  'hub.statNetProfit': 'शुद्ध लाभ',
  'hub.statCollectedMonth': 'इस महीने',
  'hub.statActiveFinance': 'वित्त रिकॉर्ड',
  'hub.statActiveLoans': 'हाथ ऋण',
  'hub.statEmiDue': 'EMI देय',
  'hub.statOverdue': 'अतिदेय',
  'hub.statActivityLog': 'गतिविधि',
  'hub.statViewLog': 'लॉग देखें',
  'hub.statBooks': 'पुस्तकें',
  'hub.statFullSuite': 'पूर्ण सूट',
  'hub.statEntries': 'प्रविष्टियाँ',
  'hub.statStaff': 'कर्मचारी',
  'hub.statAccess': 'पहुँच',
  'hub.statTeamRoles': 'टीम और भूमिकाएँ',
  'hub.statWorkspace': 'वर्कस्पेस',
  'hub.statConfigure': 'कॉन्फ़िगर',
} as const;
